import { useTranslation } from 'react-i18next';

import assets_messages from 'messages/assets_messages';

export type ImportanceLevel = 'very_high_importance' | 'high_importance' | 'low_importance' | string;

/**
 * Returns the translated label for an importance level
 */
export const getImportanceLabel = (importance: ImportanceLevel, t: (key: string | string[]) => string): string => {
  const message = (assets_messages.information_choices_assets_importance as Record<string, string[]>)[importance];
  return message ? t(message) : importance;
};

/**
 * Returns the color for an importance level
 */
export const getImportanceColor = (importance: ImportanceLevel): string => {
  switch (importance) {
    case 'very_high_importance':
      return '#f44336';
    case 'high_importance':
      return '#ff9800';
    case 'low_importance':
      return '#4caf50';
    default:
      return '#757575';
  }
};

/**
 * Hook to get importance label and color
 */
export const useImportanceHelpers = () => {
  const { t } = useTranslation();

  return {
    getLabel: (importance: ImportanceLevel) => getImportanceLabel(importance, t),
    getColor: getImportanceColor,
  };
};
